// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"a9481cda","977":"08934997"}[chunkId] + ".chunk.js";
};